import * as dateFns from 'date-fns';
import { fr, de, enUS as en, es, ar, it, nl, th } from 'date-fns/locale';

const isValidDate = period => dateFns.isValid(new Date(period));

export const dateWithoutTZ = date => dateFns.addMinutes(date, date.getTimezoneOffset());

const locales = { fr, de, es, ar, it, nl, th };

export const getLocale = locale => locales[locale] || en;

const formaterPeriod = (locale, format) => date =>
  dateFns.format(date, format, { locale: getLocale(locale) });

export const getReportedTimePeriodLabel =
  (freq, _format, locale) =>
  (reportYearStart, { id, start, reportedStart }) => {
    const isReportFirstDate = reportYearStart.month === '01' && reportYearStart.day === '01';
    if (isReportFirstDate || freq === 'D') {
      // the reporting year starts on Jan 1st (same as no reporting defined) and is of no consequence,
      // only monthly periods get the time format.
      return _format == null || freq !== 'M'
        ? id
        : dateFns.format(start, _format, { locale: getLocale(locale) });
    }
    if (freq === 'M' && dateFns.isFirstDayOfMonth(reportedStart)) {
      // the reporting year starts on the first day of a month, which allows a regular monthly display.
      return _format == null
        ? id
        : dateFns.format(reportedStart, _format, { locale: getLocale(locale) });
    }
    return id
      .replace(/\d{4}-\d{2}$/, tp => `${tp.slice(0, 4)}-M${tp.slice(5)}`)
      .replace(/\d{4}/, year => `${year}/${Number(year) + 1}`);
  };

export const getReportedTimePeriod = (reportYearStart, value, freq) => {
  let start = new Date(value.start);
  let end = dateWithoutTZ(new Date(value.end));
  if (reportYearStart.month === '01' && reportYearStart.day === '01') {
    return { start, end };
  }
  start = dateFns.addMonths(start, reportYearStart.month - 1);
  start = dateFns.addDays(start, reportYearStart.day - 1);
  if (freq === 'A') {
    end = dateFns.addYears(start, 1);
  }
  if (freq === 'S') {
    end = dateFns.addMonths(start, 6);
  }
  if (freq === 'Q') {
    end = dateFns.addMonths(start, 3);
  }
  if (freq === 'M') {
    end = dateFns.addMonths(start, 1);
  }
  if (freq === 'W' || freq === 'B') {
    end = dateFns.addDays(start, 7);
  }
  if (freq === 'D') {
    end = dateFns.addDays(start, 1);
  }
  if (freq === 'H') {
    end = dateFns.addHours(start, 1);
  }
  if (freq === 'N') {
    end = dateFns.addMinutes(start, 1);
  }
  end = dateFns.subSeconds(end, 1);
  return { start, end };
};

export const getReportedTimePeriodNote = (reportYearStart, start, end, freq) => {
  if (reportYearStart.month === '01' && reportYearStart.day === '01') {
    return null;
  }
  if (['D', 'H', 'N'].includes(freq)) {
    return null;
  }
  const isFirstDayOfMonth = dateFns.isFirstDayOfMonth(start);
  if (freq === 'M' && isFirstDayOfMonth) {
    return null;
  }
  const formatedStart = dateFns.format(start, 'yyyy-MM-dd');
  const formatedEnd = dateFns.format(end, 'yyyy-MM-dd');
  return { value: { name: `${formatedStart} - ${formatedEnd}` } };
};

export const getTimePeriodLabel =
  (locale, format = 'yyyy MMM') =>
  date => {
    const value = date == null ? '' : date;
    return isValidDate(value) ? formaterPeriod(locale, format)(value) : value;
  };
